import axios, { AxiosResponse } from "axios";
import getApiBaseUrl from "../GetServer";

export interface PlansData {
    id: number;
    name: string;
    llm: string;
    price: number;
    minutes: number;
    addMinutes: number;
    recordCalls: boolean;
    transcribeCalls: boolean;
    simultaneousCalls: number;
    localPhoneNumber: boolean;
    webChatbotIncluded: boolean;
    whatsappChatbotIncluded: boolean;
};

export interface PlansResponse {
    statusCode: number;
    message: string;
    data: PlansData[];
};

export const GetPlans = async (): Promise<PlansResponse> => {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}plans/get`;

    try {
        const response: AxiosResponse<PlansResponse> = await axios.get(
            endpoint
        );

        return response.data;
    } catch (error: any) {
        throw error.response?.data || error.message;
    }
}